"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(str) {
  var vars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = str;
  (0, _forEach2["default"])(vars, function (value, key) {
    result = result.split(':' + key).join(value);
  });
  return result;
};